module.exports = __webpack_public_path__ + "img/1-5.04d5f615.svg";